import React, { Fragment } from "react"

import {
  AccordionComponent as Accordion,
  Summary,
  Details,
  Text,
} from "components/ui/Accordion"

const Content = () => {
  return (
    <Fragment>
      <Accordion>
        <Summary>Sissejuhatus</Summary>
        <Details>
          <Text>
            Selle privaatsusteate on koostanud <strong>Fresh Finance OÜ</strong>{" "}
            (edaspidi ka: <strong>Fresh Finance</strong>, <strong>meie</strong>
            ), Eesti Vabariigis registreeritud äriühing, registrikood 12243370,
            juriidiline aadress Tartu mnt 83, 10115 Tallinn, Eesti.
          </Text>
          <Text>
            Privaatsusteade kehtib kõigile füüsilistele isikutele, kelle käest
            või kohta Fresh Finance kogub või saab isikuandmeid oma teenuste
            osutamise või muu majandustegevuse käigus (edaspidi:{" "}
            <strong>andmesubjekt</strong> või <strong>teie</strong>).
            Privaatsusteade kehtib Fresh Finance poolt töödeldavatele
            isikuandmetele. Privaatsusteade kirjeldab, kuidas Fresh Finance teie
            isikuandmeid kogub, kasutab ja muul viisil töötleb.
          </Text>
          <Text>
            Fresh Finance töötleb teie isikuandmeid kooskõlas kohaldatavate
            andmekaitsealaste õigusaktidega, sh andmekaitse üldmäärusega (määrus
            (EL) 2016/679) (edaspidi: GDPR) ja mistahes muude kohaldatavate
            andmekaitsealaste õigusaktidega.
          </Text>
          <Text>
            Teil on palju õigusi, mida te saate kasutada, et oma privaatsust
            kaitsta. Fresh Finance austab neid õigusi ja soovib aidata teil teie
            õigusi kasutada. Allpool on toodud teave, kuidas seda teha.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Vastutav töötaja</Summary>
        <Details>
          <Text>
            Fresh Finance OÜ on teie isikuandmete vastutav töötleja. Fresh
            Finance OÜ vastutab teie isikuandmete töötlemise eest kooskõlas
            selle privaatsusteatega ja kohaldatavate andmekaitsealaste
            õigusaktidega.
          </Text>
          <Text>
            Andmekaitse eest vastutava isiku kontaktandmed:
            <ul>
              <li>Krõõt Kilvet</li>
              <li>Aadress: Tartu mnt 83, 10115 Tallinn, Eesti</li>
              <li>
                E-post:{" "}
                <a href="mailto:kroot.kilvet@punkfinance.ee">
                  kroot.kilvet@punkfinance.ee
                </a>
              </li>
            </ul>
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Töödeldavad isikuandmed</Summary>
        <Details>
          <Text>
            Me võime koguda, säilitada, kasutada, edastada ja mistahes muul
            viisil töödelda teie järgmisi isikuandmeid:
            <ul>
              <li>
                isikut tuvastavad andmed (eesnimi, perekonnanimi, isikukood,
                sünniaeg ja -koht, kodakondsus, isikut tõendava dokumendi andmed
                ja koopia, foto jne);
              </li>
              <li>
                kontaktandmed (aadress, telefoninumber, e-posti aadress jne);
              </li>
              <li>
                tööhõive andmed (praegune tööandja, tööhõive ajalugu, ametikoht
                jne);
              </li>
              <li>
                finantsandmed (sissetulek, vara, kohustused, tagatised ja pandid
                jne);
              </li>
              <li>
                lepingut ja selle täitmist puudutavad andmed (praegused ja
                varasemad meiega sõlmitud lepingud, makseajalugu ja -häired,
                tehingud, laenutaotlused jne);
              </li>
              <li>
                teie majandustegevusega seotud andmed, nt seotud isikute andmed
                äriregistrist;
              </li>
              <li>teie IP-aadress;</li>
              <li>
                karistusregistri teave, riikliku taustaga isiku teave jne.
              </li>
            </ul>
          </Text>
          <Text>
            Olenevalt isikuandmete liigist ja nende töötlemise alustest ei
            pruugi Fresh Finance suuta täita lepingulisi kohustusi ega jätkata
            lepingulist suhet juhul, kui te keeldute teatud isikuandmete
            avaldamisest.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Isikuandmete kogumise allikad</Summary>
        <Details>
          <Text>
            Kogume teie isikuandmeid järgmistest allikatest:
            <ul>
              <li>
                teilt endalt – osa isikuandmeid saame teilt laenutaotlusega,
                telefoni või meili teel, interneti iseteeninduse vahendusel või
                muul moel, kui te meiega suhtlete;
              </li>
              <li>
                konsolideerimisgrupi ettevõtetelt, kuhu Fresh Finance kuulub;
              </li>
              <li>
                kolmandatelt isikutelt, sh avalikest allikatest, nagu
                e-andmebaasidest (nt maksehäirete register, äriregister,
                pensioniregister, kinnistusraamat, karistusregister),
                otsingumootoritest, ametiasutustest (kohtud, kohtutäiturid,
                pankrotihaldurid) ja muudelt isikutelt.
              </li>
            </ul>
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Isikuandmete töötlemise eesmärgid</Summary>
        <Details>
          <Text>
            Fresh Finance töötleb teie isikuandmeid kooskõlas kohaldatavate
            andmekaitsealaste õigusaktidega. Kui see on põhjendatud ja kooskõlas
            kohaldatavate õigusaktidega ning neist tulenevate nõuetega, töötleme
            kliendiandmeid üldiselt järgmistel eesmärkidel:
            <ul>
              <li>
                kliendi või käendaja krediidivõimekuse ning kliendile pakutava
                toote, teenuse või pandi sobivuse hindamine;
              </li>
              <li>tagatise sobivuse hindamine;</li>
              <li>lepingu ettevalmistamine, koostamine ja sõlmimine;</li>
              <li>kliendipoolse lepingu täitmise kontrollimine;</li>
              <li>õigusnõuete koostamine, esitamine või kaitsmine;</li>
              <li>
                nõuetekohase hoolsuskohustuse ja muude regulatiivsete nõuete
                täitmine;
              </li>
              <li>raamatupidamine ja aruandlus;</li>
              <li>teile uute pakkumiste tegemine.</li>
            </ul>
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Isikuandmete töötlemise õiguslik alus</Summary>
        <Details>
          <Text>
            Fresh Finance on teie isikuandmete töötlemiseks mitmeid erinevaid
            õiguslikke aluseid.
          </Text>
          <Text>
            Need on järgmised:
            <ul>
              <li>
                ettevalmistuste tegemine teiega lepingu sõlmimiseks (GDPR-i
                artikkel 6 lõige 1 punkt b);
              </li>
              <li>
                lepinguliste kohustuste täitmine teie ees ning veendumine, et
                teie täidate oma kohustused Fresh Finance ees (GDPR-i artikkel 6
                lõige 1 punkt b);
              </li>
              <li>
                meie juriidiliste kohustuste täitmine (GDPR, artikkel 6 lõige 1
                punkt c), mis tulenevad näiteks rahapesu ja terrorismi
                rahastamise tõkestamise seadusest, võlaõigusseadusest,
                krediidiandjate ja -vahendajate seadusest, raamatupidamise
                seadusest, audiitortegevuse seadusest, rahvusvahelise
                sanktsiooni seadusest;
              </li>
              <li>
                teie andmete töötlemine meie õigustatud huvides (GDPR, artikkel
                6 lõige 1 punkt f), peamiselt, kui:
                <ul>
                  <li>
                    teie isikuandmete töötlemine on meile vajalik, et koostada,
                    esitada või kaitsta õigusnõudeid;
                  </li>
                  <li>
                    teie isikuandmete töötlemine on vajalik, et hinnata
                    võimalikke kliente, käendajaid ja tagatise pakkujaid
                    ulatuses, mida ei nõua kohaldatav õigus;
                  </li>
                  <li>
                    teie isikuandmete töötlemine on vajalik, et teha teile uusi
                    pakkumisi.
                  </li>
                </ul>
              </li>
              <li>
                te olete andnud töötlemiseks nõusoleku (GDPR, artikkel 6 lõige 1
                punkt a).
              </li>
            </ul>
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Isikuandmete jagamine</Summary>
        <Details>
          <Text>
            Selleks, et saavutada käesolevas privaatsusteates kirjeldatud
            töötlemise eesmärgid, võime edastada teie isikuandmeid järgmistele
            saajatele:
            <ul>
              <li>
                selle konsolideerimisgrupi ettevõtted, kuhu Fresh Finance
                kuulub;
              </li>
              <li>
                ametiasutused, nagu Maksu- ja Tolliamet, Finantsinspektsioon,
                rahapesu andmebüroo, andmebaaside vastutavad töötlejad;
              </li>
              <li>
                pilvepõhise salvestusteenuse pakkujad, sealhulgas pilvepõhise
                laenuhaldustarkvara pakkuja;
              </li>
              <li>klienditoe keskuse teenusepakkujad;</li>
              <li>
                ettevõtted, kes pakuvad pettuste ja finantskuritegude ennetamise
                teenuseid;
              </li>
              <li>
                muud kolmandad isikud, nagu kulleri- ja postiteenuse pakkujad,
                maksehäirete registrid, võlgade sissenõudjad, audiitorid,
                õigusteenuse pakkujad, kohtud, kohtutäiturid, pankrotihaldurid
                jne.
              </li>
            </ul>
          </Text>
          <Text>
            Nõuame kolmandatest isikutest teenusepakkujatelt, et nad hoiaksid
            teie andmeid turvaliselt ja töötleksid seda meie juhiste ja nõuete
            järgi, mis on omakorda kooskõlas selle teate, GDPR-i ja kohaldatava
            õigusega.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Edastamine väljapoole euroopa majanduspiirkonda</Summary>
        <Details>
          <Text>
            Edastame andmeid väljapoole Euroopa Majanduspiirkonda (EMP, s.t
            Euroopa Liidu liikmesriigid, Norra, Island ja Liechtenstein) ainult
            juhul, kui see on kooskõlas andmekaitsealaste õigusaktidega ja
            edastusviis kaitseb teie andmeid piisavalt. Mis puudutab edastamist
            riikidesse, mis ei taga kaitse piisavat taset, toetume asjakohastele
            kaitsemeetmetele, nagu Euroopa Komisjoni vastu võetud standardsed
            andmekaitseklauslid või heakskiidetud sertifitseerimismehhanismid
            koos vastuvõtja siduvate ja täidetavate kohustustega. Kui soovite
            lisainfot isikuandmete edastamise ja rakendatavate kaitsemeetmete
            kohta, võtke meiega ühendust privaatsusteates sisalduvatel
            kontaktandmetel.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Isikuandmete säilitamine ja turvalisus</Summary>
        <Details>
          <Text>
            Me ei säilita teie isikuandmeid kauem, kui see on vajalik töötlemise
            eesmärkide saavutamiseks. Isikuandmete säilitusperioodi määramisel
            lähtume järgmistest kriteeriumidest:
            <ul>
              <li>eesmärk, milleks isikuandmeid koguti;</li>
              <li>ajaperioodi pikkus, mil Fresh Finance on teiega seotud;</li>
              <li>
                juriidilise kohustuse olemasolu kohaldatava õiguse alusel;
              </li>
              <li>
                vajalikkus Fresh Finance õigusliku seisundi tõttu (näiteks nõude
                aegumine, kohtuvaidlus või regulatiivsed menetlused).
              </li>
            </ul>
          </Text>
          <Text>
            Kui oleme teinud kindlaks, et me ei vaja enam teie isikuandmeid,
            kustutame need Fresh Finance süsteemidest.
          </Text>
          <Text>
            Kasutame üldtunnustatud tehnoloogilisi ja töökindluse tagamise
            abinõusid, et kaitsta teie isikuandmeid kaotsimineku, väärkasutuse,
            muutmise ja hävitamise eest. Nõuame oma töötajatelt, et nad hoiaksid
            isikuandmeid konfidentsiaalsena. Juurdepääs isikuandmetele on ainult
            volitatud töötajatel.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Teie õigused</Summary>
        <Details>
          <Text>
            Teil on oma töödeldavate isikuandmete suhtes mitmeid õigusi.
            <ul>
              <li>
                <strong>Õigus taotleda andmetega tutvumist:</strong> võite igal
                ajal paluda, et me kinnitaksime, milliseid teie andmeid me
                töötleme. Võime teie taotluse tagasi lükata, kui seda nõuab
                seadus. Kui me keeldume taotluse täitmisest, teatame teile selle
                põhjuse.
              </li>
              <li>
                <strong>Õigus andmete parandamisele:</strong> võite nõuda, et me
                parandaksime töödeldavaid isikuandmeid, kui need on ebatäpsed
                või puudulikud. Kui oleme jaganud sellist teavet kolmandate
                isikutega, teavitame neid parandusest, v.a juhul, kui see on
                võimatu või nõuab ebamõistlikke jõupingutusi. Võime teie
                taotluse tagasi lükata, kui meil on selleks seadusest tulenev
                õigus. Kui me keeldume taotluse täitmisest, teatame teile selle
                põhjuse.
              </li>
              <li>
                <strong>Õigus andmete kustutamisele:</strong> teil on teatud
                juhtudel õigus nõuda, et me kustutaksime teie isikuandmed. Võime
                teie taotluse tagasi lükata, kui meil on selleks seadusest
                tulenev õigus. Kui me keeldume taotluse täitmisest, teatame
                teile selle põhjuse.
              </li>
              <li>
                <strong>Õigus isikuandmete töötlemise piiramisele:</strong> teil
                on teatud juhtudel õigus nõuda oma isikuandmete töötlemise
                piiramist. See tähendab, et me võime teie andmeid ainult
                säilitada, kuid ei tohi neid mingil muul moel töödelda. Võime
                teie taotluse tagasi lükata, kui meil on selleks seadusest
                tulenev õigus. Kui me keeldume taotluse täitmisest, teatame
                teile selle põhjuse.
              </li>
              <li>
                <strong>Õigus esitada vastuväiteid:</strong> teil on teatud
                juhtudel õigus esitada vastuväiteid oma isikuandmete
                töötlemisele. Võime teie taotluse tagasi lükata, kui meil on
                selleks seadusest tulenev õigus. Kui me keeldume taotluse
                täitmisest, teatame teile selle põhjuse.
              </li>
              <li>
                <strong>Andmete ülekandmise õigus:</strong> teil on õigus
                edastada oma isikuandmeid vastutavate töötlejate vahel, kuid
                sellele võivad kehtida piirangud olenevalt kohaldatavast
                õigusest. See tähendab, et te tohite edastada meie poolt
                töödeldavaid andmeid teisele teenusepakkujale või kolmandale
                isikule. Esitame teile teie isikuandmed üldkasutatavas
                masinloetavas vormingus, nii et te saate edastada need teisele
                teenusepakkujale.
              </li>
              <li>
                <strong>
                  Õigus, et teie kohta ei tehtaks otsust, mis põhineb üksnes
                  automatiseeritud töötlusel:
                </strong>{" "}
                teil on õigus, et teie kohta ei võetaks otsust, mis põhineb
                üksnes automatiseeritud töötlusel, sealhulgas profiilianalüüsil,
                mis toob kaasa teid puudutavaid õiguslikke tagajärgi või avaldab
                teile sarnast märkimisväärset mõju. Seda õigust piirab
                kohaldatav õigus. Võime teie taotluse tagasi lükata, kui meil on
                selleks seadusest tulenev õigus. Kui me keeldume taotluse
                täitmisest, teatame teile selle põhjuse.
              </li>
              <li>
                <strong>Järelevalveasutusele kaebuse esitamise õigus:</strong>{" "}
                kui teil on kaebusi selle suhtes, kuidas me teie isikuandmeid
                käitleme, võite pöörduda Andmekaitse Inspektsiooni poole
                järgmistel kontaktidel: Andmekaitse Inspektsioon, Tatari 39,
                10134 Tallinn, telefon: +372 627 4135, e-post:{" "}
                <a href="mailto:info@aki.ee">info@aki.ee</a>.
              </li>
            </ul>
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Muudatused</Summary>
        <Details>
          <Text>
            Kui Fresh Finance muudab töödeldavate isikuandmete kategooriaid või
            töötlemise eesmärke, teeme privaatsusteatesse vastavasisulised
            muudatused ja teavitame teid nendest.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Lisateave</Summary>
        <Details>
          <Text>
            Kui teil on privaatsusteate või oma isikuandmete kohta küsimusi,
            saatke meile e-kiri aadressil{" "}
            <a href="mailto:kroot.kilvet@punkfinance.ee">
              <strong>kroot.kilvet@punkfinance.ee</strong>
            </a>
            .
          </Text>
        </Details>
      </Accordion>
    </Fragment>
  )
}

export default Content
